export default __webpack_public_path__ + "static/media/file-download.15f15ed0.svg";